
import { useLocalTranslation } from "@/hooks/useLocalTranslation";
import { examStatusEnu } from '@/pages/dashboard/constants'
import StrikeBar from "@/pages/exam/com/strikeBar";
import { userWebsitePaths } from "@/constants/userWebsitePaths";

import PreviousBtn from "@/assets/svg/previousBtn.svg";
import NextBtn from "@/assets/icons/nextBtn.png";
import BlackClock from "@/assets/svg/blackClock.svg"
import "./style.css"
import ExamSkeletonLoader from "@/components/common/examLoader";
import { allPaths } from "@/constants/urlPaths";
import { useSafeAreaInsets } from "@/hooks/useSafeAreaInsets";

export default function ExamMainView(props: any) {
    const {
        isLoading,
        questionBank,
        checkEligibilityApiObj,
        handleRichTextEditorCourseDiscription,
        examSubmitBtnIsLoading,
        examStartBtnIsLoading,
        handleStartExam,
        displayExamTimer,
        examQuestionBank,
        currentPage,
        totalPages,
        onPageChange,
        handleSelectedOption,
        examSubmitBtnIsLocked,
        examStrikes,
        handleExamSubmit } = props

    const { common } = useLocalTranslation();
    const { bottomSafeComponent } = useSafeAreaInsets();
    const homePath: any = process.env.REACT_APP_USER_PANEL_URL;
    const explorePath: any = homePath + userWebsitePaths.explore;


    // locked: "locked",
    // unlocked: "unlocked",
    // started: "started",
    // submitted: "submitted",
    // viewResult: "viewResult",
    // hideResult: "hideResult"


    return (
        <>
            <div className="min-h-screen examMainViewCon0">

                {/* <p className="text-red-600 font-semibold text-sm">examStrikes: {examStrikes}</p> */}

                <div className="examPageMainContainer">

                    {isLoading ? (
                        <ExamSkeletonLoader />
                    ) : (
                        <>
                            {/* ----------- START d1 */}
                            {checkEligibilityApiObj.currentExamStatus
                                && checkEligibilityApiObj.currentExamStatus === examStatusEnu.started &&
                                <div className="row examDurationContainer">
                                    <div className="col-md-6 col-12 strikeContainer order-md-1 order-2">
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                            }}
                                        >
                                            <span style={{ fontSize: "12px" }}>
                                                {common.statusText.strikesAllowed}
                                            </span>
                                            <StrikeBar
                                                windowBlurFlag={
                                                    examStrikes > 4
                                                        ? 0
                                                        : examStrikes
                                                }
                                            />
                                        </div>
                                        <div className="examStrikeNoteContainer">
                                            <span>
                                                {common.statusText.strikesN1}
                                                <span style={{ color: "#FF7A00" }}>*</span>
                                            </span>
                                        </div>
                                    </div>

                                    <div className="col-md-6 col-12 durationContainer order-md-2 order-1">
                                        <span style={{ fontSize: "12px" }}>
                                            {common.statusText.timeRemaining}

                                        </span>

                                        <span className="duration">
                                            {/* 0h 23m 3s */}
                                            {displayExamTimer !== "" && displayExamTimer}
                                        </span>
                                    </div>
                                </div>
                            }
                            {/* ----------- END d1 */}


                            {/* ----------- START d2 */}
                            <div className="examPageHeadingContainer">
                                <h3 className="questionBankTitle">{questionBank.title}</h3>
                                <hr style={{ margin: "15px 0px 10px 0px" }} />

                                {checkEligibilityApiObj.currentExamStatus &&
                                    (checkEligibilityApiObj.currentExamStatus === examStatusEnu.unlocked
                                        || checkEligibilityApiObj.currentExamStatus === examStatusEnu.started) &&
                                    <div className="pointers">
                                        <div
                                            className="courseContentDescriptionContainerNon"
                                            id="courseContentDescriptionContainer"
                                            dangerouslySetInnerHTML={{
                                                __html:
                                                    handleRichTextEditorCourseDiscription(
                                                        questionBank?.instructions
                                                            .description,
                                                        questionBank?.instructions.bulletIcon,
                                                        ""
                                                    ),
                                            }}
                                        />
                                    </div>
                                }


                                {checkEligibilityApiObj.currentExamStatus
                                    && checkEligibilityApiObj.currentExamStatus === examStatusEnu.submitted &&
                                    <div style={{ display: "flex" }}>
                                        <div style={{ marginRight: "15px" }}>
                                            <img
                                                style={{ width: "22px" }}
                                                src={BlackClock}
                                                alt="TimerIcon"
                                            />
                                        </div>

                                        <div>
                                            <p style={{ marginBottom: "5px" }}>
                                                Exam Submitted. Result will update
                                                automatically in{" "}
                                                {props.questionBank?.declarationResultInDays}{" "}
                                                days
                                            </p>
                                            <p style={{ color: "#717171" }}>
                                                <a
                                                    style={{
                                                        color: "#717171",
                                                        textDecoration: "underline"
                                                    }}
                                                    href={allPaths.dashboard}
                                                >
                                                    Click here
                                                </a>
                                                {" "}to go to My learning
                                            </p>
                                        </div>
                                    </div>
                                }
                            </div>
                            {/* ----------- END d2 */}



                            {checkEligibilityApiObj.currentExamStatus
                                && checkEligibilityApiObj.currentExamStatus === examStatusEnu.unlocked &&
                                <div className="startExamBtnContainer">
                                    <button
                                        disabled={examStartBtnIsLoading}
                                        style={{
                                            cursor: examStartBtnIsLoading ? 'not-allowed' : 'cursor',
                                            opacity: examStartBtnIsLoading ? '0.7' : '1',
                                        }}
                                        onClick={handleStartExam}
                                        className="startExamBtn"
                                    >
                                        Start Exam
                                    </button>
                                </div>
                            }

                            {/* ----------- START d3 */}
                            {checkEligibilityApiObj.currentExamStatus
                                && checkEligibilityApiObj.currentExamStatus === examStatusEnu.started
                                && examQuestionBank
                                && examQuestionBank.length > 0 &&
                                <div className="questionMainCon">
                                    <br />
                                    {examQuestionBank.map((questionData: any, questionDataIndex: any) => (
                                        <div
                                            className="singleQuestionCon"
                                            key={questionDataIndex}>
                                            <p className="questionTitle">                                                
                                                {questionData.question}
                                            </p>
                                            
                                            {/* {console.log(questionData)} */}
                                            {/* <br />
                                            ---{questionData.answer}
                                            <br /> */}

                                            {questionData.thumbnailUrl && (
                                                <center>
                                                    <img
                                                        className="questionsThumbnailUrl"
                                                        src={questionData.thumbnailUrl}
                                                        alt="thumbnailUrl"
                                                    />
                                                </center>
                                            )}

                                            {questionData.options.map((option: any, optionIndex: any) => (
                                                <div
                                                    className="questionOptionCon"
                                                    key={optionIndex}>
                                                        
                                                    <input
                                                        name={"radio_" + questionDataIndex}
                                                        id={
                                                            questionDataIndex +
                                                            "_" +
                                                            optionIndex
                                                        }
                                                        onChange={(event) => {
                                                            handleSelectedOption(
                                                                questionData._id,
                                                                option
                                                            );
                                                        }}
                                                        checked={
                                                            questionData.selectedOption ===
                                                                option
                                                                ? true
                                                                : false
                                                        }
                                                        type="radio" />
                                                    <label
                                                        htmlFor={
                                                            questionDataIndex +
                                                            "_" +
                                                            optionIndex
                                                        }>
                                                        {option}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    ))}
                                </div>
                            }
                            {/* ----------- END d3 */}



                            {/* ----------- START Pagination controls */}
                            {checkEligibilityApiObj.currentExamStatus
                                && checkEligibilityApiObj.currentExamStatus === examStatusEnu.started
                                && examQuestionBank
                                && examQuestionBank.length > 0 &&

                                <div className="pageNavigationBtn">
                                    <img
                                        style={{
                                            visibility: currentPage === 1
                                                ? "hidden"
                                                : "visible",
                                        }}
                                        onClick={() => onPageChange(currentPage - 1)}
                                        src={PreviousBtn}
                                        alt="PreviousBtn"
                                    />

                                    {currentPage !== totalPages ? (
                                        <>
                                            <img
                                                onClick={() => onPageChange(currentPage + 1)}
                                                src={NextBtn}
                                                alt="NextBtn"
                                            />
                                        </>
                                    ) : (
                                        <>
                                            <div className="submitExamContainer">
                                                <p>Please attempt all the questions*</p>
                                                <button
                                                    style={{
                                                        cursor: (examSubmitBtnIsLoading || examSubmitBtnIsLocked) ? 'not-allowed' : 'pointer',
                                                        opacity: (examSubmitBtnIsLoading || examSubmitBtnIsLocked) ? '0.7' : '1',
                                                    }}
                                                    disabled={examSubmitBtnIsLoading || examSubmitBtnIsLocked}
                                                    onClick={handleExamSubmit}>
                                                    Submit
                                                </button>
                                            </div>
                                        </>
                                    )}
                                </div>
                            }
                            {/* ----------- END Pagination controls */}

                        </>
                    )}
                </div>
                {bottomSafeComponent}
            </div>
        </>
    );
}
